import * as queryString from "query-string";
import axios from "axios";

export type TAppSettings = {
    key: string,
    name: string,
    start: string,
    suffix: string
}

export const  isIntern = () => {
    if (window.location.href.includes("localhost") || window.location.href.includes("blksencop1")){
        return true;
    }
    return false;
}

export const isExtendet = () => {
    return Settings.args.modus && isIntern() ? true : false;
}

export const isFromConfigurator = () => {
    return Settings.args.articlename || Settings.args.articlename || Settings.args.theme || Settings.args.language || Settings.args.org
}

const getBaseUrl = () => {
    if (isIntern()){
        return "http://blksencop12.fra.hager.corp/configuratorlist/"
    }    
    return "https://configuration.hager.com/configuratorlist/"
}

export const Settings = {
    dataConnection: axios.create({
        baseURL: getBaseUrl(),
        timeout: 60000,
        }),
    args : queryString.parse(window.location.search),
    environment: {
        server: "http://blksencop11.fra.hager.corp/",
        app: [
            {
                key: "3D",
                name:"hager-trunking-server",
                start: "productfinderid",
                suffix: "#/guide"
            },{
                key: "ELCOM",
                name: "hager-elcom-server",
                start: "",
                suffix: ""
            },{
                key: "Q&A",
                name: "hager-acb-external-server",
                start: "articlename",
                suffix: ""
            }
        ]
    }
}